<template>
  <div class="todo_wrapper">
    <!-- Header & Quick Input -->
    <header class="todo_header">
      <!-- <div class="header_meta">
        <h2 class="app_title">To-Do</h2>
        <span class="task_counter" v-if="!isLoading">
          {{ completedCount }} / {{ totalCount }} Completed
        </span>
      </div> -->

      <div class="task-input">
        <form @submit.prevent="createToDoInfoMethod">
          <i class="fa fa-pencil-square-o input_icon" aria-hidden="true"></i>
          <input type="text" placeholder="Add a new to-do and press Enter..." class="form-control" v-model="title"
            name="title" v-validate="'required'" :class="{ 'is-invalid': errors && errors.has('title') }"
            autocomplete="off">
          <button type="submit" class="btn_quick_add" :disabled="!title.trim()">
            <span>Add</span>
            <kbd>↵</kbd>
          </button>
        </form>
      </div>
    </header>

    <!-- Main Content Area -->
    <div class="todo_info_wrp">
      <template v-if="!isLoading">
        <!-- Controls Strip: Filters & Clear All -->
        <div class="controls">
          <div class="filters">
            <button type="button" v-for="tab in filterTabs" :key="tab.id" class="filter_pill"
              :class="{ active: filterToDoActv === tab.id }" @click="filterToDoActvMethod(tab.id)">
              {{ tab.label }}
              <span class="count_badge">{{ tab.count }}</span>
            </button>
          </div>

          <button type="button" class="btn_clear_all" v-if="displayedTodoList.length > 0"
            @click="openAllToDoRemovePopup">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
            <span>Clear All</span>
          </button>
        </div>

        <!-- Task Stream -->
        <div class="todo_list_info">
          <ul class="task-box" v-if="displayedTodoList.length > 0">
            <li class="task" v-for="item in displayedTodoList" :key="item.id" :class="{ is_done: item.is_completed }">
              <label :for="'todo-chk-' + item.id" class="todo_label">
                <input type="checkbox" :id="'todo-chk-' + item.id" :checked="item.is_completed"
                  @change="todoCompletemethod(item)">
                <span class="custom_checkbox">
                  <i class="fa fa-check" aria-hidden="true"></i>
                </span>
                <div class="todo_task_content">
                  <p class="task_title">{{ item.title }}</p>
                  <span class="todo_created_date">
                    <i class="fa fa-calendar-o" aria-hidden="true"></i>
                    {{ item.created_at | LocalDateFormat }}
                  </span>
                </div>
              </label>

              <!-- Actions Strip -->
              <div class="settings">
                <button type="button" class="btn_action delete_btn" title="Delete task"
                  @click="openSelectedToDoRemovePopup(item.id)">
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>

                <button type="button" class="btn_action share_btn" title="Share task"
                  @click="openToDoSharedPopupMethod(item)">
                  <i class="fa fa-share-alt" aria-hidden="true"></i>
                </button>
              </div>
            </li>
          </ul>

          <!-- Empty State -->
          <div class="todo_empty_state" v-else>
            <div class="empty_icon">
              <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <p class="empty_title">All clear</p>
            <p class="empty_subtitle">{{ emptyStateMessage }}</p>
          </div>
        </div>
      </template>

      <!-- Loading State -->
      <div class="fixloader userLoading" v-else>
        <div class="spinner spinner-1"></div>
      </div>
    </div>

    <!-- Confirmation Modal: Delete Single Task -->
    <div class="remove_todo_popup_wrp" v-if="removeToDoPopup">
      <div class="modal_backdrop" @click="closeRemoveItemModalFun()"></div>
      <div class="modal_box">
        <div class="modal_icon warning">
          <i class="fa fa-trash-o" aria-hidden="true"></i>
        </div>
        <h4>Delete To-Do?</h4>
        <p>This action will permanently remove this item from your list.</p>
        <div class="modal_actions">
          <button class="btn btn_cancel" @click="closeRemoveItemModalFun()">Cancel</button>
          <button class="btn btn_danger" @click="removeToDoConfirmationMethod()">Delete</button>
        </div>
      </div>
    </div>

    <!-- Confirmation Modal: Clear All Tasks -->
    <div class="remove_todo_popup_wrp" v-if="removeAllToDoPopup">
      <div class="modal_backdrop" @click="closeRemoveAllItemModalFun()"></div>
      <div class="modal_box">
        <div class="modal_icon danger">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
        <h4>Clear All To-Do?</h4>
        <p>Are you sure you want to remove all items currently shown in this view?</p>
        <div class="modal_actions">
          <button class="btn btn_cancel" @click="closeRemoveAllItemModalFun()">Cancel</button>
          <button class="btn btn_danger" @click="removeAllToDoConfirmationMethod()">Clear All</button>
        </div>
      </div>
    </div>

    <!-- Share Subcomponent -->
    <todo-share v-if="sharedToDoState" :sharedToDoDATA="sharedToDoData"></todo-share>
  </div>
</template>

<script>
/* eslint-disable */
import toast from '@/services/toast';
import todoShare from './todo-share';
import { bus } from '@/main';

export default {
  name: 'todo-app',
  components: {
    'todo-share': todoShare
  },
  props: [],
  data() {
    return {
      title: '',
      isLoading: false,
      filterToDoActv: 'All',
      getToDoListData: null,
      getToDoListDataResults: [],
      getCompletedToDoListData: null,
      getCompletedToDoListDataResults: [],
      getPendingToDoListDataResults: [],
      getSharedToDoListData: null,
      getSharedToDoListDataResults: [],
      removeToDoPopup: false,
      removeAllToDoPopup: false,
      removeToDoId: '',
      sharedToDoState: false,
      sharedToDoData: null
    };
  },
  computed: {
    displayedTodoList() {
      if (this.filterToDoActv === 'Completed') {
        return this.getCompletedToDoListDataResults || [];
      } else if (this.filterToDoActv === 'Pending') {
        return this.getPendingToDoListDataResults || [];
      } else if (this.filterToDoActv === 'Shared') {
        return this.getSharedToDoListDataResults || [];
      }
      return this.getToDoListDataResults || [];
    },
    filterTabs() {
      return [
        { id: 'All', label: 'All', count: this.getToDoListDataResults.length },
        { id: 'Pending', label: 'Pending', count: this.getPendingToDoListDataResults.length },
        { id: 'Completed', label: 'Completed', count: this.getCompletedToDoListDataResults.length },
        { id: 'Shared', label: 'Shared', count: this.getSharedToDoListDataResults.length }
      ];
    },
    totalCount() {
      return this.getToDoListDataResults.length;
    },
    completedCount() {
      return this.getCompletedToDoListDataResults.length;
    },
    emptyStateMessage() {
      if (this.filterToDoActv === 'Completed') return 'No completed tasks found in this view.';
      if (this.filterToDoActv === 'Pending') return 'No pending items right now.';
      if (this.filterToDoActv === 'Shared') return 'No shared to-dos available.';
      return 'Create your first to-do using the input field above.';
    }
  },
  mounted() {
    this.getTodoListMethod();
    bus.$on('sharedToDoStateBus', (data) => {
      this.sharedToDoState = data;
    });
  },
  methods: {
    openToDoSharedPopupMethod(data) {
      this.sharedToDoData = data;
      this.sharedToDoState = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    filterToDoActvMethod(flag) {
      this.filterToDoActv = flag;
      this.refreshCurrentView();
    },
    refreshCurrentView() {
      if (this.filterToDoActv === 'Completed') {
        this.isLoading = true;
        this.$store.dispatch('getFiltersToDoListAction', { status: 'True' })
          .then((res) => {
            this.getCompletedToDoListData = res.data.data;
            this.getCompletedToDoListDataResults = this.getCompletedToDoListData ? this.getCompletedToDoListData.results : [];
          })
          .finally(() => { this.isLoading = false; });
      } else if (this.filterToDoActv === 'Pending') {
        this.isLoading = true;
        this.$store.dispatch('getFiltersToDoListAction', { status: 'False' })
          .then((res) => {
            this.getPendingToDoListDataResults = res.data.data ? res.data.data.results : [];
          })
          .finally(() => { this.isLoading = false; });
      } else if (this.filterToDoActv === 'Shared') {
        this.isLoading = true;
        this.$store.dispatch('getSharedToDoListAction')
          .then((res) => {
            this.getSharedToDoListData = res.data.data.shared_todo;
            this.getSharedToDoListDataResults = this.getSharedToDoListData ? this.getSharedToDoListData.results : [];
          })
          .finally(() => { this.isLoading = false; });
      } else {
        this.getTodoListMethod();
      }
    },
    getTodoListMethod() {
      this.isLoading = true;
      this.$store.dispatch('getToDoListAction')
        .then((res) => {
          this.getToDoListData = res.data.data;
          this.getToDoListDataResults = this.getToDoListData ? this.getToDoListData.results : [];

          // Pre-populate counts for tabs in the background
          this.$store.dispatch('getFiltersToDoListAction', { status: 'True' }).then((res) => {
            this.getCompletedToDoListDataResults = res.data.data ? res.data.data.results : [];
          });
          this.$store.dispatch('getFiltersToDoListAction', { status: 'False' }).then((res) => {
            this.getPendingToDoListDataResults = res.data.data ? res.data.data.results : [];
          });
          this.$store.dispatch('getSharedToDoListAction').then((res) => {
            this.getSharedToDoListDataResults = (res.data.data && res.data.data.shared_todo) ? res.data.data.shared_todo.results : [];
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    createToDoInfoMethod() {
      this.$validator.validateAll().then((result) => {
        if (result && this.title.trim()) {
          const payload = { title: this.title.trim() };
          this.$store.dispatch('postToDoListAction', payload).then(() => {
            this.title = '';
            this.$validator.reset();
            this.refreshCurrentView();
          });
        }
      });
    },
    todoCompletemethod(data) {
      const updatedStatus = !data.is_completed;
      const payload = {
        id: data.id,
        is_completed: updatedStatus
      };
      this.$store.dispatch('updateToDoInfoByIdAction', payload).then(() => {
        this.refreshCurrentView();
      });
    },
    openAllToDoRemovePopup() {
      this.removeAllToDoPopup = true;
    },
    closeRemoveAllItemModalFun() {
      this.removeAllToDoPopup = false;
    },
    removeAllToDoConfirmationMethod() {
      this.$store.dispatch('allToDoRemoveAction').then((res) => {
        toast.success(res.data.data.results || 'All to-dos cleared');
        this.closeRemoveAllItemModalFun();
        this.refreshCurrentView();
      });
    },
    openSelectedToDoRemovePopup(id) {
      this.removeToDoPopup = true;
      this.removeToDoId = id;
    },
    closeRemoveItemModalFun() {
      this.removeToDoPopup = false;
      this.removeToDoId = '';
    },
    removeToDoConfirmationMethod() {
      const payload = { id: this.removeToDoId };
      this.$store.dispatch('toDoRemoveByIdAction', payload).then((res) => {
        toast.success(res.data.data.results || 'To-do removed');
        this.closeRemoveItemModalFun();
        this.refreshCurrentView();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$surface-bg: #111111;
$surface-card: #1e293b;
$surface-card-hover: #243147;
$border-subtle: rgba(255, 255, 255, 0.08);
$text-main: #f8fafc;
$text-muted: #94a3b8;
$accent-amber: #fbbf24;
$accent-blue: #3b82f6;
$accent-rose: #f43f5e;

.todo_wrapper {
  height: 100%;
  width: 100%;
  background-color: $surface-bg;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  color: $text-main;
  box-sizing: border-box;

  /* Header Section */
  .todo_header {
    padding:10px 15px;
    background: rgba(12, 13, 18, 0.7);
    backdrop-filter: blur(20px);

    .header_meta {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 14px;

      .app_title {
        font-size: 20px;
        font-weight: 700;
        letter-spacing: -0.02em;
        margin: 0;
        color: $text-main;
      }

      .task_counter {
        font-size: 12px;
        font-weight: 600;
        color: $text-muted;
        background: rgba(255, 255, 255, 0.05);
        padding: 4px 10px;
        border-radius: 999px;
        border: 1px solid $border-subtle;
      }
    }
  }

  /* Quick-Add Input */
  .task-input {
    form {
      position: relative;
      display: flex;
      align-items: center;
    }

    .input_icon {
      position: absolute;
      left: 16px;
      font-size: 18px;
      color: $text-muted;
      top: 16px;
      pointer-events: none;
    }

    input.form-control {
      width: 100%;
      height: 48px;
      background: transparent;
      border: 1px solid $border-subtle;
      border-radius: 10px;
      padding: 0 95px 0 46px;
      font-size: 14px;
      color: $text-main;
      transition: all 0.2s ease;
      outline: none;
      box-shadow: none !important;

      &::placeholder {
        color: rgba(148, 163, 184, 0.6);
      }

      &:focus {
        border-color: #ffd400;
      }

      &.is-invalid {
        border-color: $accent-rose;
      }
    }

    .btn_quick_add {
      position: absolute;
      right: 8px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px;
      background: #ffd400;
      color: #000000;
      border: none;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: opacity 0.2s ease, transform 0.15s ease;

      kbd {
        font-family: inherit;
        font-size: 10px;
        background: rgba(67, 67, 67, 0.15);
        padding: 1px 4px;
        border-radius: 3px;
        color: #000000;
      }

      &:hover:not(:disabled) {
        transform: translateY(-1px);
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }

  .todo_info_wrp {
    background: #0b0c10;
    backdrop-filter: blur(20px);
    height: calc(100% - 68px);
  }

  /* Filter Navigation Strip */
  .controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: rgba(12, 13, 18, 0.6);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.02);
    border-top: 1px solid rgba(255, 255, 255, 0.02);

    .filters {
      display: flex;
      align-items: center;
      gap: 1px;

      .filter_pill {
        background: transparent;
        border: none;
        color: $text-muted;
        font-size: 12px;
        font-weight: 500;
        padding: 3px 7px;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.18s ease;

        .count_badge {
          font-size: 11px;
          opacity: 0.6;
        }

        &:hover {
          color: $text-main;
          background: rgba(255, 255, 255, 0.04);
        }

        &.active {
          color: $accent-amber;
          background: rgba(251, 191, 36, 0.1);
          font-weight: 600;

          .count_badge {
            opacity: 1;
            font-weight: 700;
          }
        }
      }
    }

    .btn_clear_all {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: transparent;
      border: 1px solid rgba(244, 63, 94, 0.2);
      color: #fb7185;
      font-size: 12px;
      font-weight: 500;
      padding: 6px 10px;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.18s ease;

      &:hover {
        background: rgba(244, 63, 94, 0.12);
        border-color: rgba(244, 63, 94, 0.4);
      }
    }
  }

  /* Task Stream */
  .todo_list_info {
    max-height: 400px;
    overflow-y: auto;
    padding-top: 0px;
    padding-right: 2px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }

    .task-box {
      list-style: none;
      padding: 14px 15px 0px;
      margin: 0;

      .task {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 14px;
        margin-bottom: 8px;
        background: rgba(22, 24, 33, 0.5);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.02);
        border-radius: 10px;
        transition: all 0.2s ease;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);

        &:hover {
          background: rgba(255, 255, 255, 0.05);
          border-color: rgba(255, 255, 255, 0.1);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
          -webkit-transform: translateY(-2px);
          transform: translateY(-2px);

          .settings {
            opacity: 1;
          }
        }

        &.is_done {
          background: rgba(56, 177, 36, 0.15);

          .task_title {
            text-decoration: line-through;
            color: $text-muted;
          }
        }

        .todo_label {
          display: flex;
          align-items: center;
          cursor: pointer;
          flex: 1;
          margin: 0;
          min-width: 0;

          input[type="checkbox"] {
            display: none;

            &:checked+.custom_checkbox {
              background: rgba(56, 177, 36, 0.2);
              border-color: rgba(56, 177, 36, 0.5);

              i {
                transform: scale(1);
              }
            }
          }

          .custom_checkbox {
            width: 18px;
            height: 18px;
            border-radius: 3px;
            border: 2px solid rgba(56, 177, 36, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 2px;
            flex-shrink: 0;
            transition: all 0.2s ease;

            i {
              font-size: 10px;
              color: #ffffff;
              transform: scale(0);
              transition: transform 0.15s ease;
            }
          }

          .todo_task_content {
            padding-left: 12px;
            min-width: 0;

            .task_title {
              margin: 0;
              font-size: 14px;
              font-weight: 500;
              line-height: 1.4;
              color: $text-main;
              word-break: break-word;
            }

            .todo_created_date {
              display: inline-flex;
              align-items: center;
              gap: 4px;
              margin-top: 4px;
              font-size: 11px;
              font-weight: 500;
              color: #5e6473;
            }
          }
        }

        .settings {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-left: 12px;
          opacity: 0.85;
          transition: opacity 0.2s ease;

          .btn_action {
            width: 30px;
            height: 30px;
            border-radius: 8px;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: background 0.15s ease, transform 0.15s ease;

            &:hover {
              transform: translateY(-1px);
            }

            &.delete_btn {
              background: rgba(244, 63, 94, 0.15);
              color: #fb7185;

              &:hover {
                background: $accent-rose;
                color: #ffffff;
              }
            }

            &.share_btn {
              background: rgba(59, 130, 246, 0.15);
              color: #60a5fa;

              &:hover {
                background: $accent-blue;
                color: #ffffff;
              }
            }
          }
        }
      }
    }

    .todo_empty_state {
      text-align: center;
      padding: 48px 16px;

      .empty_icon {
        font-size: 36px;
        color: rgba(148, 163, 184, 0.3);
        margin-bottom: 12px;
      }

      .empty_title {
        font-size: 15px;
        font-weight: 600;
        color: $text-main;
        margin: 0 0 4px;
      }

      .empty_subtitle {
        font-size: 13px;
        color: $text-muted;
        margin: 0;
      }
    }
  }

  /* Modals */
  .remove_todo_popup_wrp {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;

    .modal_backdrop {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.7);
      backdrop-filter: blur(4px);
    }

    .modal_box {
      background: #000000;
      /* Dark background matching the UI */
      color: #ffffff;
      border-radius: 8px;
      max-width: 500px;
      width: 100%;
      padding: 25px 15px;
      text-align: center;
      /* Distinct golden/yellowish outer glow as requested */
      box-shadow: 0 0 13px rgba(255, 213, 0, 0.6);
      border: 1px solid rgba(234, 179, 8, 0.35);
      /* Slight yellowish tint on border */
      z-index: 111;

      .modal_icon {
        font-size: 26px;
        margin-bottom: 12px;

        &.warning,
        &.danger {
          color: $accent-rose;
        }
      }

      h4 {
        font-size: 16px;
        font-weight: 600;
        color: $text-main;
        margin: 0 0 6px;
      }

      p {
        font-size: 13px;
        color: $text-muted;
        line-height: 1.5;
        margin: 0 0 20px;
      }

      .modal_actions {
        display: flex;
        gap: 8px;
        justify-content: center;

        .btn {
          padding: 8px 16px;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          border: none;
          min-width: 90px;
          transition: background 0.15s ease;

          &.btn_cancel {
            background: rgba(255, 255, 255, 0.08);
            color: $text-main;

            &:hover {
              background: rgba(255, 255, 255, 0.14);
            }
          }

          &.btn_danger {
            background: $accent-rose;
            color: #ffffff;

            &:hover {
              background: darken($accent-rose, 6%);
            }
          }
        }
      }
    }
  }
}
</style>